import { component } from 'picoapp'
import { docReady, waitForElement } from '../lib/utils'
import $ from '../lib/quantdom'

export default component((node) => {
  const url = new URL(window.location)
  const initVariantId = $(node).attr('data-init-variant-id')
  url.searchParams.set('variant', initVariantId)
  history.replaceState({}, '', url)

  docReady(() => {
    //used for quick buy on product page
    if ($('.dynamic-payment-button').el() !== null) {
      waitForElement(
        '.shopify-payment-button__button div[role="button"]',
        (el) => {
          const buttonDisplay = getComputedStyle($('.dynamic-payment-button').el()).display
          const { testid } = el.dataset
          const label = testid.split('-button')[0].split('InContext')[0]

          if (buttonDisplay !== 'none') {
            window.gtag('event', 'Quick Buy Button', {
              event_category: 'displayed',
              event_label: label,
            })
          }

          $(el).on('click', () => {
            window.gtag('event', 'Quick Buy Button', {
              event_category: 'click',
              event_label: label,
            })
          })
        },
        5000
      )
    }
  })
})
